import { apiClient } from "shared/utils";
import { PutSensitivityRequest } from "api/models";

export const putSensitivity = async ({ shopId, sensitivity }: PutSensitivityRequest) => {
  await apiClient.put<void>(`${shopId}/activation-popups/sensitivity`, {
    sensitivity
  });
};
